module.exports = __webpack_public_path__ + "static/media/close-img-white.57d14016.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-img-white.svg
// module id = 909
// module chunks = 0